import { DEFAULT_NODE_WIDTH } from 'common/builder/components/chart/FlowChart/nodes/shared/config'
import * as sharedStyles from 'common/builder/components/chart/FlowChart/nodes/shared/styles'

export const CARD_WIDTH = DEFAULT_NODE_WIDTH - sharedStyles.Spacings.NODE_HORIZONTAL_PADDING * 2
